import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'
import './scss/style.scss'
import AuthenticatedRoute from './AuthenticatedRoute' // Import the component
import ChatbotWidget from './components/ChatbotWidget'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

// Email App
const EmailApp = React.lazy(() => import('./views/apps/email/EmailApp'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <CookiesProvider>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route exact path="/register" name="Register Page" element={<Register />} />
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route
                path="/apps/email/*"
                name="Email App"
                element={
                  <AuthenticatedRoute>
                    <EmailApp />
                  </AuthenticatedRoute>
                }
              />
              <Route
                path="*"
                name="Home"
                element={
                  <AuthenticatedRoute>
                    <DefaultLayout />
                  </AuthenticatedRoute>
                }
              />
            </Routes>
            <ChatbotWidget />
          </Suspense>
        </CookiesProvider>
      </HashRouter>
    )
  }
}

export default App
